if (typeof MultilayerImage === "undefined") {
  class MultilayerImage extends HTMLElement {
    constructor() {
      super();

      const firstItem = this.querySelector(".image-item:first-child");

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("item-active");
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: "-100px 0px",
        },
      );

      if(firstItem) observer.observe(firstItem);

      // Nova versão em JavaScript puro (substitui o jQuery)
      const imageItems = this.querySelectorAll(".image-item");
      
      imageItems.forEach(item => {
        item.addEventListener("mouseenter", () => {
          if (!item.classList.contains("item-active")) {
            const activeItem = this.querySelector(".image-item.item-active");
            if (activeItem) {
              activeItem.classList.remove("item-active");
            }
            item.classList.add("item-active");
          }
        });
      });
    }
  }

  customElements.define("multilayer-image", MultilayerImage);
}